import http from '../config'
const login = {
  status({
    withoutLogin
  }) {
    return http({
      url: 'login/status',
      withoutLogin
    })
  },
  logout() {
    return http({
      url: 'test/logout'
    })
  },
  loginOut() {
    return http({
      url: 'central_auth/login_out'
    })
  }
}
export default login
